


















import {Component} from 'vue-property-decorator'
import {mixins} from 'vue-class-component'
import {Action, State} from 'vuex-class'
import InfiniteScrollHandler from '../../lib/InfiniteScrollHandler'
import {TopbarButton} from '@/store/modules/topbar'
import {ReservationResponse} from '@/lib/kepler/interfaces'
import {PopupState} from '@/store'
import {ProfileState} from '@/store/modules/profile'
import {BookingState} from '@/store/modules/booking'
import Utils from '@/utils'
import AddDriver from '../../components/AddDriver.vue'
import HistoryBookingDetail from './HistoryBookingDetail.vue'

@Component({
  components: {
    AddDriver,
    HistoryBookingDetail,
    Button: Utils.loadComponent('Button'),
    ProgressLinear: Utils.loadComponent('proxy/ProgressLinear'),
    EmptyList: Utils.loadComponent('EmptyList'),
    CardReservation: Utils.loadComponent('entities/reservation/CardReservation'),
    InfiniteLoading: Utils.loadComponent('infiniteScroll/InfiniteLoading'),
  },
  mixins: [InfiniteScrollHandler],
})
export default class MyDriversListHistory extends mixins<InfiniteScrollHandler>(InfiniteScrollHandler) {
  @Action('selectReservation') public selectReservation!: any
  @Action('openPopup') public openPopup!: (popup: PopupState) => void
  @Action('setActionButtons') public setActionButtons!: any
  @Action('myDriversReservations') public myDriversReservations!: any
  @Action('flushAndReloadDriversReservationsHistory') public flushAndReloadDriversReservationsHistory!: any
  @State('profile') public profileState!: ProfileState
  @State('booking') public bookingState!: BookingState

  protected isLoading: boolean = false
  protected reservations: ReservationResponse[] = []
  protected max: number = Infinity

  protected mounted() {

    if (this.bookingState.driversReservations.items.length === 0) {
      this.flushAndReloadDriversReservationsHistory()
    }

    const buttons: TopbarButton[] = [
      {
        icon: 'mdi-refresh',
        action: () => {
          this.reloadHistory()
        },
      },
    ]
    this.setActionButtons(buttons)
  }

  protected infiniteHandler(state: any) {
    (this as any).handler(state, this.max, this.bookingState.driversReservations, this.myDriversReservations)
  }

  protected openDetail(reservation: ReservationResponse) {
    this.openPopup(new PopupState(HistoryBookingDetail, {reservation}, this.$t('booking.reservation', {number: reservation.number})))
  }

  protected inviteDriver() {
    this.openPopup(
      new PopupState(AddDriver, null, 'Invite Driver'),
    )
  }

  protected reloadHistory() {
    const infinite = (this.$refs.infiniteLoader as any)
    infinite.isLoading = true
    this.flushAndReloadDriversReservationsHistory().then(() => {
      infinite.isLoading = false
    })
  }

  protected get hasDrivers() {
    return this.profileState.drivers.filter((d) => {
      return !d.main_driver
    }).length
  }
}
